import Cookies from 'js-cookie';

import { trackV2 } from '@gumtree/shell/src/common/common-actions';
import {
    PermutiveEventNames,
    trackPermutiveCustomEvent,
} from '@gumtree/shared/src/util/permutive/track-event';

export const COOKIE_EXPIRY_TIME = 1 / 48; // 15 minutes from now

const trySetCookiePhoneRevealBegin = (
    userLoggedIn,
    advertId,
    showRevealNumber,
    isLoginRequiredToContactForVipCategory,
    domain
) => {
    if (
        userLoggedIn === false &&
        showRevealNumber === false &&
        isLoginRequiredToContactForVipCategory === true
    ) {
        Cookies.set(`R2SPhoneBegin_${advertId}`, 'R2SPhoneBegin', {
            domain,
            expires: COOKIE_EXPIRY_TIME,
        });
    }
};

const trySetCookiePhoneRevealSuccess = (
    userLoggedIn,
    advertId,
    showRevealNumber,
    isLoginRequiredToContactForVipCategory,
    domain
) => {
    if (
        userLoggedIn === true &&
        showRevealNumber === true &&
        isLoginRequiredToContactForVipCategory === true
    ) {
        if (Cookies.get(`R2SPhoneBegin_${advertId}`)) {
            trackV2('R2SPhoneRevealSuccess', 'R2SPhoneRevealSuccess');
            trackPermutiveCustomEvent(window, PermutiveEventNames.R2S_PHONE_REVEAL_SUCCESS, {});
            // Cleanup
            Cookies.remove(`R2SPhoneBegin_${advertId}`, {
                domain,
            });
        }
    }
};

const trySetCookieLoginBegin = (userLoggedIn, domain) => {
    if (userLoggedIn === false) {
        Cookies.set('LoginBegin', 'LoginBegin', {
            domain,
            expires: COOKIE_EXPIRY_TIME,
        });
    }
};

const trySetCookieLoginSuccess = (userLoggedIn, domain) => {
    if (userLoggedIn === true) {
        if (Cookies.get('LoginBegin')) {
            trackV2('LoginSuccess', 'LoginSuccess');
            // Cleanup
            Cookies.remove('LoginBegin', {
                domain,
            });
        }
    }
};

export {
    trySetCookiePhoneRevealBegin,
    trySetCookiePhoneRevealSuccess,
    trySetCookieLoginBegin,
    trySetCookieLoginSuccess,
};
